import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { MinimizedDrawersProvider } from './context/MinimizedDrawersProvider';
import { DiamMinimizedDisplayArea } from './DiamMinimizedDisplayArea';
import { EditTeamDrawerProvider } from './components/EditTeamDrawer/EditTeamDrawer';
import DashboardPage from './pages/DashboardPage';
import IdentitiesPage from './pages/IdentitiesPage';
import IdentityDetailsPage from './pages/IdentityDetailsPage';
import RolesPage from './pages/RolesPage';
import RoleDetailsPage from './pages/RoleDetailsPage';
import TeamsPage from './pages/TeamsPage';
import TeamDetailsPage from './pages/TeamDetailsPage';
import InvitationsPage from './pages/InvitationsPage';
import AuditLogsPage from './pages/AuditLogsPage';

const DiamContent = () => (
  <Routes>
    <Route index element={<Navigate to="dashboard" replace />} />
    <Route path="dashboard" element={<DashboardPage />} />
    <Route path="identities" element={<IdentitiesPage />} />
    <Route path="identities/:identityId" element={<IdentityDetailsPage />} />
    <Route path="roles" element={<RolesPage />} />
    <Route path="roles/:roleCategory/:roleId" element={<RoleDetailsPage />} />
    <Route path="teams" element={<TeamsPage />} />
    <Route path="teams/:teamId" element={<TeamDetailsPage />} />
    <Route path="invitations" element={<InvitationsPage />} />
    <Route path="audit-logs" element={<AuditLogsPage />} />
  </Routes>
);

export default function Diam() {
  return (
    <MinimizedDrawersProvider>
      <EditTeamDrawerProvider>
        <DiamContent />
        <DiamMinimizedDisplayArea />
      </EditTeamDrawerProvider>
    </MinimizedDrawersProvider>
  );
}
